import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ProjectsUpsellRequestSources } from 'modules/project_management/components/upsells/constants'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

const ScheduleEmptyState = () => {
  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.projects}
      featureRequested={Features.projects_overview}
      requestReason={ValidReasons.UpgradeFromLegacy}
      requestSource={ProjectsUpsellRequestSources.scheduleEmptyState}
      title={i18n.t('project_management.upselling.title')}
      description={i18n.t('project_management.upselling.schedule')}
      buttonLabel={i18n.t('project_management.upselling.cta')}
    />
  )
}

export default ScheduleEmptyState
